import { render, staticRenderFns } from "./anchorManagement.vue?vue&type=template&id=4af22c32&scoped=true&"
import script from "./anchorManagement.vue?vue&type=script&lang=js&"
export * from "./anchorManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af22c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af22c32')) {
      api.createRecord('4af22c32', component.options)
    } else {
      api.reload('4af22c32', component.options)
    }
    module.hot.accept("./anchorManagement.vue?vue&type=template&id=4af22c32&scoped=true&", function () {
      api.rerender('4af22c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/liveData/anchorManagement.vue"
export default component.exports